import React from 'react'
import { Grid } from '@material-ui/core'
import { EasyPayPlanTitle } from './EasyPayPlanTitle'
import EasyPayPlanOptionsGroup from './EasyPayPlanOptionsGroup'
import { EasyPayPlanAdvertiseDialog } from './EasyPayPlanAdvertiseDialog'

export const EasyPayPlanCard = () => {
  return (
    <section aria-label='easyPayPlan'>
      <Grid container lg={11} md={12} sm={12} xs={12}>
        <EasyPayPlanAdvertiseDialog />
        <EasyPayPlanTitle />
        <EasyPayPlanOptionsGroup />
      </Grid>
    </section>
  )
}
